module.exports = __webpack_public_path__ + "img/horizontal_7_6_3016.00a392a7.png";